export default "__VITE_ASSET__88b9350f__"